<div *ngIf="isDataLoaded" class="container pb-10">
  <app-table
    [data]="usersForTable"
    [displayedColumns]="adminColumns"
    [type]="TableType.ORDER_VIEW"
    pageTitle="admin_page.header_item.orders"
  ></app-table>
</div>
